import React from 'react'
import './MetricCard.css'

const MetricCard = ({ title, value, format }) => {
  const formatValue = (val) => {
    if (format === 'currency') {
      return `$${val.toLocaleString()}`
    }
    if (format === 'number') {
      return val.toLocaleString()
    }
    if (format === 'text') {
      return val
    }
    return val
  }

  return (
    <div className="metric-card">
      <h3 className="metric-title">{title}</h3>
      <p className="metric-value">{formatValue(value)}</p>
    </div>
  )
}

export default MetricCard

